<template>
	<div class="modal__confirm">
		<UiButtonIcon
			padding="10px"
			:background="'#EAEDF5'"
		>
			<Icon
				v-if="!$slots?.['customIcon']"
				name="material-symbols:verified-rounded"
				color="#3CB3AD"
				:style="{ fontSize: '22px' }"
			/>
			<slot name="customIcon" />
		</UiButtonIcon>
		<TypographyKTypographyBody4
			color="#000000"
			class="modal__confirm-title"
			font-type="bold"
		>
			{{ title }}
		</TypographyKTypographyBody4>
		<TypographyKTypographyBody5
			v-if="subtitle"
			color="#757484"
			class="modal__confirm-subtitle"
			font-type="regular"
		>
			{{ subtitle }}
		</TypographyKTypographyBody5>
		<slot />
		<div class="actions">
			<UiButton
				:color="ButtonType.outline"
				:size="ButtonSizeType.small"
				@click="closeModal"
			>
				{{ 'Отмена' }}
			</UiButton>
			<UiButton
				v-if="isNeedSaveBtn"
				:color="ButtonType.primary"
				:size="ButtonSizeType.small"
				:is-loading="isLoading"
				@click="saveHandler"
			>
				{{ btnConfirmTitle }}
			</UiButton>
		</div>
	</div>
	<div
		class="blackout"
		@click="closeModal"
	></div>
</template>

<script setup lang="ts">
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['update:modelValue', 'save']);

	const props = withDefaults(
		defineProps<{
			modelValue: boolean;
			title: string;
			subtitle?: string;
			zIndex?: number;
			customPadding?: string;
			maxWidth?: string;
			isLoading?: boolean;
			btnConfirmTitle?: string;
			isNeedSaveBtn?: boolean;
		}>(),
		{
			zIndex: 10000,
			customPadding: '34px 27px',
			maxWidth: '350px',
			btnConfirmTitle: 'Подтвердить'
		}
	);

	const closeModal = () => {
		emits('update:modelValue', false);
	};

	const saveHandler = () => {
		emits('save', '');
	};

	const zIndexForModal = computed(() => {
		return { blackout: props.zIndex - 1, modal: props.zIndex };
	});
</script>

<style scoped lang="scss">
	.blackout {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: v-bind('zIndexForModal.blackout');
		background-color: var(--blackout);
	}

	.modal__confirm {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		text-align: center;
		position: fixed;
		max-width: v-bind(maxWidth);
		width: calc(100% - 40px);
		border-radius: 20px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		right: 0px;
		z-index: v-bind('zIndexForModal.modal');
		background-color: #ffffff;
		padding: v-bind(customPadding);
		overflow: auto;
		box-shadow: 0px 1px 21px 0px var(--color-shadow);

		.logo {
			display: flex;
			justify-content: center;
			width: fit-content;
		}

		&-subtitle {
			line-height: 22px;
			margin-top: 7px;
		}

		&-title {
			line-height: 22px;
			margin-top: 16px;
		}

		.actions {
			display: flex;
			gap: 10px;
			width: 100%;
			margin-top: 30px;

			button {
				width: 100%;
			}
		}
	}
</style>
